// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"53":"1f888144","351":"1f888144","594":"1f888144","619":"7690248c","865":"c3c52f51"}[chunkId] + ".chunk.css";
};